module.exports = __webpack_public_path__ + "static/img/malware-scan.f8f0611.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/malware-scan.png
// module id = IbsF
// module chunks = 1